import { mobileNavbarHeight, colors } from '@zopauk/react-components';
import { NavbarTheme } from '@zopauk/react-components/types/components/styles/Theme';

export const navbar: NavbarTheme = {
  logoContainer: {
    desktopMinMedia: {
      justifyContent: 'center',
      paddingLeft: '0',
      height: '68px',
      width: '100%',
    },
    desktopMaxMedia: {
      alignItems: 'center',
      display: 'flex',
    },
  },
  mobile: {
    minHeight: `${mobileNavbarHeight}`,
    bgColor: colors.white,
  },
  layoutInner: {
    justifyContent: 'center',
  },
  iconContainer: {
    display: 'none',
  },
  logo: {
    render: false,
  },
  // Replace this with TailwindCSS classes in the future
  containerClassName: 'jl-navbar-container',
  href: 'https://www.johnlewisfinance.com/',
};
